import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { get } from '../../services/http'

import { SliceStatus } from '../../interfaces/Redux';
import routeListen from '../../services/routeListen';
import config from '../../application/Config';
import { Notifications } from '../../interfaces/notifications';


export interface AppState {
  status: SliceStatus
  userNotifications:Notifications[]
  userId: number
  error?: string
}

const initialState: AppState = {
  status: SliceStatus.initial,
  userNotifications: [],
  userId: 0
}

export const userNotificationSlice = createSlice({
  name: 'userNotifications',
  initialState,
  reducers: {
    setUserId: (state, action) => {
        state.userId = action.payload
    },
    resetNotifications: () => initialState 
  },
  extraReducers: (builder) => {
    builder
        .addCase(fetchUserNotifications.pending, (state) => {
            state.status = SliceStatus.loading;
            state.error = undefined;
        })
        .addCase(fetchUserNotifications.fulfilled, (state, action) => {
        if(action.payload) {
            state.status = SliceStatus.succeeded;
            
            state.userNotifications = action.payload.hasSkip
                ? [...state.userNotifications, ...action.payload.notifications]
                : action.payload.notifications;
            state.error = undefined;
        }
        
        })
        .addCase(fetchUserNotifications.rejected, (state, action) => {
            state.status = SliceStatus.failed
            state.error = action.error.message
        })
    }
  
})

export const fetchUserNotifications = createAsyncThunk('userNotifiactions/getUserNotifications', async (skip?:number) => {
    
    const { data } = await get(`api/app/${routeListen.appGuid()}/notificationalerts?skip=${skip ? skip : 0}&top=${config.notifications.limit}`)
      .catch((response) => {
        throw new Error(response.message);
      });
    return {notifications: data?.notifications, hasSkip: !!skip}
});

export const { setUserId, resetNotifications } = userNotificationSlice.actions 

export default userNotificationSlice.reducer
